<template>
  <LazyHydrate never :trigger-hydration="isSidebarOpen">
    <el-drawer
      :visible="isSidebarOpen"
      direction="ltr"
      :show-close="false"
      :before-close="toggleSideBar"
      size="280px"
      class="lad-sidebar"
    >
      <template slot="title">
        <LadNavigationLogo />

        <LadNavigationMenuShoppingCart
          mode="vertical"
          class="lad-navigation--menu--shopping-cart"
        />
      </template>

      <LadNavigationMenu mode="vertical" />
    </el-drawer>
  </LazyHydrate>
</template>

<script>
import { mapState } from 'vuex'
import LadNavigationMenuShoppingCart from './components/ShoppingCart'

export default {
  name: 'LadSidebar',
  components: {
    LadNavigationMenuShoppingCart,
    LadNavigationLogo: () =>
      import(/* webpackChunkName: "lad-navi-logo" */ './components/Logo'),
    LadNavigationMenu: () =>
      import(/* webpackChunkName: "lad-navi-menu" */ './components/Menu'),
  },
  computed: {
    ...mapState('app', {
      isSidebarOpen: (state) => state.sidebar.opened,
    }),
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
  },
}
</script>

<style lang="scss">
.lad-sidebar {
  .el-drawer__header {
    margin: 0;
    padding: 20px 30px 20px 20px;
    justify-content: space-between;

    .lad-navigation--logo {
      max-width: 130px;
      padding: 0;
    }

    .lad-navigation--menu--shopping-cart {
      border: 0;

      .el-menu-item {
        padding: 0 !important;

        &.is-active {
          color: #909399;
        }

        a {
          display: block;

          .right-shopcart {
            margin: 0;
          }
        }
      }
    }
  }

  .el-drawer__body {
    position: relative;
  }

  .lad-navigation {
    &--logo {
      padding: 40px 30px;
      // background-color: aliceblue;

      .sprite-icons {
        width: 100%;
        max-height: 75px;
      }
    }

    &--menu {
      position: absolute;
      height: 100%;
      width: 100%;
      display: flex;
      flex-direction: column;

      &--wrapper {
        overflow: auto;
        flex: 1;
      }

      &--auth {
        border-right: 0;

        & > li {
          background: #67c23a;
          text-align: center;
          font-weight: 550;
          color: white;
          cursor: pointer;

          i {
            color: white;
          }

          .el-submenu__title {
            color: white;
          }

          .el-submenu__title:hover {
            background: #67c23a;
          }

          &:hover {
            background: #78d34b;
          }
        }
      }

      &--contact {
        .el-menu {
          .el-menu-item {
            padding-left: 20px !important;
            height: auto;

            h3 {
              margin: 0;
            }
          }
        }

        .el-submenu {
          .el-menu-item a {
            padding: 0;
          }
        }
      }

      &--currency,
      &--language {
        .el-menu {
          .el-menu-item {
            padding-left: 40px !important;
          }
        }
      }

      &--destinations {
        .el-main {
          padding: 0;
        }

        .el-submenu__title .fa-map-marker-alt {
          margin-right: 5px;
        }

        h3 {
          margin: 0;
        }

        .lad-limiter--btn {
          padding: 0 40px;
        }
      }

      @media screen and (min-width: 1501px) {
        &--main,
        &--trips,
        &--destinations {
          display: none !important;
        }
      }

      @media screen and (min-width: 1201px) {
        &--contact {
          display: none !important;
        }
      }

      @media screen and (min-width: 994px) {
        &--language,
        &--currency {
          display: none !important;
        }
      }

      @media screen and (min-width: 769px) {
        &--auth {
          display: none !important;
        }
      }
    }
  }

  .el-submenu {
    .el-menu-item.lad-install-pwa {
      display: none;
    }
  }
}
</style>
